<template>
    <!-- Meta Tags -->
    <Head title="Productos" />

    <nav class="flex my-8 px-4" aria-label="Breadcrumb">
        <div class="container">
            <ol class="inline-flex items-center space-x-1 md:space-x-2">
                <li class="inline-flex items-center">
                    <Link
                        href="/"
                        class="inline-flex items-center text-sm font-medium text-white hover:text-orange hover:underline"
                    >
                        <svg
                            aria-hidden="true"
                            class="w-4 h-4 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                            ></path>
                        </svg>
                        Inicio
                    </Link>
                </li>
                <li aria-current="page">
                    <div class="flex items-center">
                        <svg
                            aria-hidden="true"
                            class="w-6 h-6 text-white"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                        <span class="ml-1 text-sm font-bold md:ml-2">Productos</span>
                    </div>
                </li>
            </ol>
        </div>
    </nav>

    <!-- start Products Slider -->
    <section class="container mt-8 mb-10 md:mb-16" ref="bannerSection">
        <h1 class="text-left md:text-center mb-8 md:mb-14 uppercase">Productos</h1>
        <swiper
            :a11y="{
                prevSlideMessage: 'Anterior',
                nextSlideMessage: 'Siguiente',
            }"
            :pagination="{
                clickeable: true,
            }"
            :navigation="true"
            :loop="true"
            :modules="modules"
            class="swiperSlider"
        >
            <swiper-slide>
                <img
                    class="w-full h-auto"
                    :src="`/images/products/nuevo-banner.png`"
                    alt="Chokis®"
                />
            </swiper-slide>
            <swiper-slide>
                <img
                    class="w-full h-auto"
                    :src="`/images/products/nuevo-banner.png`"
                    alt="Chokis®"
                />
            </swiper-slide>
        </swiper>
    </section>
    <!-- End Products Slider -->

    <section class="container mb-16" id="main-content">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            <div
                v-for="(product, index) in products"
                :key="index"
                v-if="products.length"
                class="group w-full rounded-2xl overflow-hidden"
            >
                <div
                    class="w-full h-52 flex justify-center items-center bg-cover bg-no-repeat bg-center"
                    :style="{
                        backgroundImage: `url(storage/products/backgrounds/${product.background})`,
                    }"
                >
                    <div
                        v-if="product.special_edition"
                        class="absolute top-[33px] -left-[47px] -rotate-45 bg-red text-white px-8 py-1 mt-1 rounded text-md font-bold text-sm"
                    >
                        Edición Limitada
                    </div>

                    <img class="w-full h-full p-4 object-contain" :src="product.image" :alt="product.name" />
                </div>
                <div class="bg-blue w-full h-24 flex justify-between items-center p-4">
                    <p class="text-sm pr-2 md:text-base">
                        {{ product.name }}
                    </p>
                    <Link
                        :href="product.url"
                        class="text-sm md:text-base btn-white shrink-0 hover:bg-red"
                        :aria-label="`Ver más sobre ${product.name}`"
                    >
                        Ver más
                    </Link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, A11y } from "swiper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
    name: "Index",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        products: Object,
    },
    data() {
        return {
            modules: [Navigation, Pagination, A11y],
            backgrounds: [
                "bg-blueCircles2",
                "bg-skyblueCircles",
                "bg-redCircles",
                "bg-yellowCircles",
                "bg-blueCircles",
                "bg-purpleCircles",
                "bg-skyblueCircles2",
            ],
        };
    },
    mounted() {
        gsap.fromTo(
            this.$refs.bannerSection,
            {
                opacity: 0,
                translateY: 100,
            },
            {
                scrollTrigger: {
                    trigger: this.$refs.bannerSection,
                    toggleActions: "play none none none",
                },
                opacity: 1,
                translateY: 0,
                duration: 1.3,
            }
        );

        const timeline = gsap.timeline({});
        const products = document.querySelectorAll(".group");

        products.forEach((item) => {
            timeline.fromTo(
                item,
                {
                    opacity: 0,
                    translateY: 100,
                },
                {
                    opacity: 1,
                    translateY: 0,
                    duration: 0.2,
                }
            );
        });
    },
};
</script>
<style>
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
}

.swiper-pagination-bullet-active {
    background: theme("colors.white");
}

.swiper-button-prev {
    left: 0px;
    right: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 2.8rem;
    height: 2.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-prev:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

.swiper-button-next {
    right: 0px;
    left: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 2.8rem;
    height: 2.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-next:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

/* swiperSlider */
.swiperSlider .swiper-button-prev {
    left: 0.5rem;
}

.swiperSlider .swiper-button-next {
    right: 0.5rem;
}

.swiper-button-lock {
    display: none !important;
}
</style>
